import identity from "lodash/identity";
import isArray from "lodash/isArray";
import { getAttribute } from "PFCore/helpers/get_attribute";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { FetchFilterOptionsResponse } from "PFCore/services/filters/fetch_filter_options";
import { AccessLevel, Id } from "PFTypes";
import { FilterOptionsQueryParams } from "PFTypes/filters_v2";
import { useCallback } from "react";

export const useBookingCategoryFilterOptionsQuery = () => {
  const { bookingCategories } = useBookingCategories();

  return useCallback(
    ({ value, term }: FilterOptionsQueryParams): Promise<FetchFilterOptionsResponse> => {
      const categories = bookingCategories
        .filter((item) => {
          const accessLevel = getAttribute(item, "bookingsPermissions");
          return (
            !item.archived && (accessLevel === AccessLevel.ReadWrite || accessLevel === AccessLevel.ReadOnly)
          );
        })
        .map((category) => ({
          id: category.id,
          text: category.display_as!
        }));

      const searchCondition = term
        ? (category: { text: string }) => category.text.toLowerCase().includes(term.toLowerCase())
        : value && isArray(value)
          ? (category: { id: number }) => (value as Id[]).map(Number).includes(category.id)
          : identity;

      const matchingCategories = categories.filter(searchCondition);
      return Promise.resolve({ entries: matchingCategories, meta: { total: matchingCategories.length } });
    },
    [bookingCategories]
  );
};
